import IconActionButton from "./IconActionButton";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const DeleteIconButton = ({title, disabled = false, onClick}) => (
    <IconActionButton
        disabled={disabled}
        title={title}
        onClick={onClick}
        className="text-red-700 ml-3"
    >
        <DeleteOutlineOutlinedIcon fontSize="small"/>
    </IconActionButton>
);

export default DeleteIconButton;
